// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeDetails_root__3zYn9","text":"EmployeeDetails_text__3ui_U","details":"EmployeeDetails_details__1aKdE","buoy":"EmployeeDetails_buoy__LoGWA"};